module.exports = __webpack_public_path__ + "img/loading.91712595.svg";